"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanSocialShare = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
require("components/social-share/social-share");
var react_1 = tslib_1.__importDefault(require("react"));
var ReactCanWrapper_1 = require("../../../ReactCanWrapper");
exports.CanSocialShare = function () {
    var options = new can_1.default.Map();
    var template = "\n        <social-share\n            title=\"Share\"\n            {expandedDesktop}=\"true\"\n            {page-path}=\"" + window.location.href + "\"\n        />\n    ";
    return (react_1.default.createElement(ReactCanWrapper_1.ReactCanWrapper, { template: template, options: options, className: 'c-social-share-container' }));
};
